const MAILTO_URI_DELIMITER_PATTERN = /[/?#&,;]/;
const MAILBOX_LOCAL_PART_PATTERN = /^[a-z0-9.!#$'+_`{|}~-]+$/i;
const MAILBOX_DOMAIN_LABEL_PATTERN = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

export function createContactUsHref(supportEmail: unknown): string | null {
    if (
        typeof supportEmail !== 'object' ||
        supportEmail === null ||
        !('recipient' in supportEmail) ||
        typeof supportEmail.recipient !== 'string' ||
        !('subject' in supportEmail) ||
        typeof supportEmail.subject !== 'string'
    ) {
        return null;
    }

    const recipient = supportEmail.recipient.trim();
    const subject = supportEmail.subject.trim();

    if (!isSingleMailbox(recipient) || !subject) return null;

    return `mailto:${recipient}?subject=${encodeURIComponent(subject)}`;
}

function isSingleMailbox(recipient: string): boolean {
    if (MAILTO_URI_DELIMITER_PATTERN.test(recipient)) return false;

    const mailboxParts = recipient.split('@');
    if (mailboxParts.length !== 2) return false;

    const [localPart, domain] = mailboxParts;
    if (
        !localPart ||
        localPart.length > 64 ||
        localPart.startsWith('.') ||
        localPart.endsWith('.') ||
        localPart.includes('..') ||
        !MAILBOX_LOCAL_PART_PATTERN.test(localPart)
    ) {
        return false;
    }

    const domainLabels = domain?.split('.') ?? [];
    return (
        domainLabels.length >= 2 &&
        domainLabels.every(
            (label) =>
                label.length <= 63 && MAILBOX_DOMAIN_LABEL_PATTERN.test(label)
        )
    );
}
